/**
 * Design system component: CategoryChip
 *
 * Small pill label displaying a human-readable category name with
 * category-specific background and text colours from the design token palette.
 * Accepts the raw DB enum value (e.g. 'BOARD_GAME') and maps it to display
 * text via `CATEGORY_LABEL`. Falls back to `CAT_FALLBACK` colours when the
 * category is unknown.
 */
import { memo } from 'react';
import { T, CAT_FALLBACK, CATEGORY_LABEL } from '@/lib/tokens';

interface CategoryChipProps {
  category: string;
}

export const CategoryChip = memo(function CategoryChip({ category }: CategoryChipProps) {
  const colours = T.cat[category] ?? CAT_FALLBACK;
  const label = CATEGORY_LABEL[category] ?? category;

  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 600,
        padding: '1px 6px',
        borderRadius: 4,
        background: colours.bg,
        color: colours.text,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}
    >
      {label}
    </span>
  );
});
